import { Switch, Route, Router as WouterRouter } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "next-themes";

// Pages
import Home from "@/pages/home";
import Work from "@/pages/work";
import WorkDetail from "@/pages/work-detail";
import About from "@/pages/about";
import Experience from "@/pages/experience";
import FieldNotes from "@/pages/field-notes";
import FieldNoteDetail from "@/pages/field-note-detail";
import Contact from "@/pages/contact";
import Privacy from "@/pages/privacy";
import Terms from "@/pages/terms";
import DataDeletion from "@/pages/data-deletion";
import PeptideDashboard from "@/pages/peptides";
import FunnelIndex from "@/pages/funnels/index";
import BPC157Funnel from "@/pages/funnels/bpc157";
import Admin from "@/pages/admin";
import NotFound from "@/pages/not-found";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/work" component={Work} />
      <Route path="/work/:slug" component={WorkDetail} />
      <Route path="/about" component={About} />
      <Route path="/experience" component={Experience} />
      <Route path="/field-notes" component={FieldNotes} />
      <Route path="/field-notes/:slug" component={FieldNoteDetail} />
      <Route path="/contact" component={Contact} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/terms" component={Terms} />
      <Route path="/data-deletion" component={DataDeletion} />
      <Route path="/peptides" component={PeptideDashboard} />
      <Route path="/admin" component={Admin} />
      <Route path="/funnels" component={FunnelIndex} />
      <Route path="/funnels/BPC-157" component={BPC157Funnel} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, "")}>
            <Router />
          </WouterRouter>
          <Toaster />
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
